import log from "cslog";
import React from "react";
// import Dropdown from "../../forms/elements/Dropdown";
import debounce from "lodash/debounce";
import { useEffect, useState } from "react";
import { usePageDbConfig } from "../../../../db";
import { mobile, parseStyle, tablet } from "../../../../juntion";

function QSearch({ id, db, device, gs, dydb, ctx }) {
    const data = db[id];
    const [page_dbc, setPageDBC] = usePageDbConfig(ctx.page_id);
    const [search_input, setSearchInput] = useState("");

    const ps = parseStyle(data, gs, data.cstate);

    const tabletStyle = tablet(device) ? ps.tablet : {};
    const mobileStyle = mobile(device) ? ps.mobile : {};

    let input = ps.input;
    input = { ...input, ...(tablet(device) && ps.itablet) };
    input = { ...input, ...(mobile(device) && ps.imobile) };

    // log.d(input, "Form Input");

    const search_config = {
        source: input.dataSource,
    };

    const handleSearch = debounce((text) => {
        const trimmed_text = text.trim();
        log.d(trimmed_text, "trimmed text");
        if (trimmed_text.length >= 3 || trimmed_text.length === 0) {
            // setPageSearch({
            //     [search_config.source]: text,
            // });
            if (search_config.source) {
                setPageDBC({
                    ...page_dbc,
                    [search_config.source]: {
                        ...(page_dbc[search_config.source] || {}),
                        search: text,
                        page_no: 1,
                    },
                });
            }
        }
    }, 1000);

    useEffect(() => {
        handleSearch(search_input);
    }, [search_input]);

    return (
        <div>
            {search_config.source ? (
                <div className="qui-form">
                    <div className="qfield">
                        <input
                            placeholder="Search"
                            value={search_input}
                            onChange={(e) => setSearchInput(e.target.value)}
                        />
                    </div>
                </div>
            ) : (
                <p>Search not configured properly</p>
            )}
        </div>
    );
}

export default QSearch;
